import { STATS } from '../constants';
import styles from './StatsStrip.module.css';

export default function StatsStrip({ accent }) {
  return (
    <div className={styles.strip}>
      {STATS.map((stat) => (
        <div key={stat.label} className={styles.stat}>
          <span
            className={styles.value}
            style={{ color: accent, transition: 'color 0.5s ease' }}
          >
            {stat.value}
          </span>
          <span className={styles.label}>{stat.label}</span>
        </div>
      ))}
    </div>
  );
}
